import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printDispute = (user: User, dispid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getdispsitconfreport",
		params: {
			userid: user.userId,
			dispid,
		},
	});
};

export default printDispute;
